import { render, staticRenderFns } from "./dynamicDetail.vue?vue&type=template&id=02663798&scoped=true&"
import script from "./dynamicDetail.vue?vue&type=script&lang=js&"
export * from "./dynamicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02663798",
  null
  
)

export default component.exports